// src/components/LoginPage.jsx
import React, { useState } from "react";
import { login } from "../auth/authClient";

const wrap = {
  maxWidth: 520,
  margin: "60px auto",
  padding: 20,
  border: "1px solid #d1d5db",
  borderRadius: 18,
  background: "#fff",
  boxShadow: "0 12px 30px rgba(15,23,42,0.08)",
};
const input = {
  width: "100%",
  padding: "10px 12px",
  borderRadius: 10,
  border: "1px solid #cbd5e1",
  outline: "none",
};
const btn = {
  width: "100%",
  padding: "12px 14px",
  borderRadius: 12,
  border: "1px solid #111827",
  fontWeight: 900,
  cursor: "pointer",
  background: "#111827",
  color: "#fff",
};

function PickCard({ active, title, subtitle, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        flex: 1,
        textAlign: "left",
        padding: 16,
        borderRadius: 14,
        border: active ? "2px solid #111827" : "1px solid #d1d5db",
        background: active ? "#f9fafb" : "#fff",
        cursor: "pointer",
      }}
    >
      <div style={{ fontWeight: 900, fontSize: 18, color: "#111827" }}>{title}</div>
      <div style={{ marginTop: 6, fontSize: 13, color: "#6b7280" }}>{subtitle}</div>
    </button>
  );
}

export default function LoginPage({ onLoggedIn }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [moduleChoice, setModuleChoice] = useState("pohrebka");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const r = await login(username, password);

      try {
        localStorage.setItem("pohrebka_appMode", moduleChoice);
      } catch {}

      if (typeof onLoggedIn === "function") {
        onLoggedIn(r?.user || null, moduleChoice);
      }
    } catch (e2) {
      setErr(e2?.message || "Přihlášení selhalo");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={wrap}>
      <h2 style={{ marginTop: 0, marginBottom: 14 }}>Přihlášení</h2>

      <div style={{ fontSize: 13, fontWeight: 900, marginBottom: 8 }}>Vyber modul</div>
      <div style={{ display: "flex", gap: 12, marginBottom: 16 }}>
        <PickCard
          active={moduleChoice === "pohrebka"}
          title="Pohřebka"
          subtitle="Hlavní systém pohřební služby"
          onClick={() => setModuleChoice("pohrebka")}
        />
        <PickCard
          active={moduleChoice === "udrzba"}
          title="Údržba hrobů CK"
          subtitle="Zakázky údržby hrobů a účetní přehled"
          onClick={() => setModuleChoice("udrzba")}
        />
      </div>

      {err ? (
        <div
          style={{
            border: "1px solid crimson",
            color: "crimson",
            padding: 10,
            borderRadius: 10,
            fontWeight: 800,
            marginBottom: 12,
          }}
        >
          {err}
        </div>
      ) : null}

      <form onSubmit={onSubmit}>
        <div style={{ fontSize: 13, fontWeight: 900, marginBottom: 6 }}>Uživatelské jméno</div>
        <input
          style={input}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoComplete="username"
        />

        <div style={{ fontSize: 13, fontWeight: 900, margin: "12px 0 6px" }}>Heslo</div>
        <input
          style={input}
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
        />

        <button style={{ ...btn, marginTop: 16 }} disabled={loading}>
          {loading
            ? "Přihlašuji…"
            : moduleChoice === "udrzba"
            ? "Přihlásit do Údržby hrobů"
            : "Přihlásit do Pohřebky"}
        </button>
      </form>
    </div>
  );
}
